(function() {
  document.addEventListener('click', function(e) {
    const card = e.target.closest('.variant-picker__card');
    if (!card) return;
    selectVariant(card);
  });

  // Keyboard support for the variant radio cards (D4): Enter/Space activate
  // the focused card exactly like a click, reusing the same selection logic.
  // W-5 adds radiogroup arrow-key navigation in the same delegated listener:
  // arrows move the selection to the adjacent card and follow it with focus,
  // wrapping at both ends and never touching keys outside a card (closest guard).
  document.addEventListener('keydown', function(e) {
    const card = e.target.closest('.variant-picker__card');
    if (!card) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      selectVariant(card);
      return;
    }

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      moveVariantSelection(card, e.key);
    }
  });

  function selectVariant(card) {
    const picker = card.closest('.variant-picker');
    if (!picker) return;

    const variantId = card.dataset.variantId;
    if (!variantId) return;

    var cards = picker.querySelectorAll('.variant-picker__card');
    cards.forEach(function(c) {
      c.classList.remove('variant-picker__card--selected');
      c.setAttribute('aria-checked', 'false');
    });

    card.classList.add('variant-picker__card--selected');
    card.setAttribute('aria-checked', 'true');

    // Keep the roving tabindex in sync with the selection: the checked card is
    // the group's single tab stop, every other card is removed from tab order.
    updateRovingTabindex(picker, card);

    var section = picker.closest('[data-section-id]');
    var purchaseArea = section
      ? section.querySelector('[data-purchase-area]')
      : document.querySelector('[data-purchase-area]');
    if (!purchaseArea) return;

    var formInput = purchaseArea.querySelector('input[name="id"]');
    if (formInput) {
      formInput.value = variantId;
    }

    var shippingInfo = section
      ? section.querySelector('[data-shipping-info]')
      : document.querySelector('[data-shipping-info]');
    if (shippingInfo) {
      var shippingWeight = shippingInfo.querySelector('[data-shipping-weight]');
      var shippingWeightItem = shippingInfo.querySelector('.shipping-info__weight');
      if (shippingWeight && shippingWeightItem) {
        shippingWeight.textContent = card.dataset.shippingWeight;
        shippingWeightItem.hidden = !card.dataset.shippingWeight;
      }
    }

    var variantEl = purchaseArea.querySelector('.purchase-area__variant');
    if (variantEl) {
      variantEl.textContent = card.dataset.title;
    }

    var qtyValueEl = purchaseArea.querySelector('[data-qty-value]');
    var qtyInputEl = purchaseArea.querySelector('[data-qty-input]');
    if (qtyValueEl) qtyValueEl.value = '1';
    if (qtyInputEl) qtyInputEl.value = '1';

    var currentEl = purchaseArea.querySelector('.purchase-area__current');
    if (currentEl) {
      currentEl.textContent = card.dataset.priceFormatted;
      currentEl.dataset.unitPrice = card.dataset.unitPrice;
    }

    var originalEl = purchaseArea.querySelector('.purchase-area__original');

    if (card.dataset.hasSale === 'true') {
      if (originalEl) {
        originalEl.textContent = card.dataset.compareFormatted;
        originalEl.dataset.unitOriginal = card.dataset.unitOriginal;
        originalEl.classList.remove('hidden');
      }
    } else if (originalEl) {
      originalEl.classList.add('hidden');
    }

    var bundleContainer = purchaseArea.querySelector('[data-purchase-area-bundle]');
    if (bundleContainer) {
      var bundleHtml = card.querySelector('.variant-picker__bundle-html');
      if (bundleHtml) {
        var html = bundleHtml.innerHTML.trim();
        switchBundle(bundleContainer, html);
      }
    }

    // "What's in the box" follows the selected variant for bundle-driven
    // products (server renders per-variant template nodes it can't show until a
    // selection exists). Resolve the box module document-wide because it lives
    // in a different section than the variant picker, then swap in the bundle
    // items for the newly selected variant.
    var boxData = document.querySelector('[data-box-variant-data]');
    var boxList = document.querySelector('[data-box-list]');
    var boxBaseItem = boxList ? boxList.querySelector('[data-box-base-item]') : null;
    if (boxData && boxList && boxBaseItem) {
      var boxTemplate = boxData.querySelector('[data-box-variant-template][data-variant-id="' + variantId + '"]');
      var boxFragment = document.createDocumentFragment();
      var clone = boxBaseItem.cloneNode(true);
      boxFragment.appendChild(clone);
      if (boxTemplate) {
        boxTemplate.content.querySelectorAll('[data-box-bundle-item]').forEach(function(el) {
          boxFragment.appendChild(el.cloneNode(true));
        });
      }
      boxList.innerHTML = '';
      boxList.appendChild(boxFragment);
    }

    var atcBtn = purchaseArea.querySelector('.purchase-area__atc');
    if (atcBtn) {
      var blockText = atcBtn.dataset.blockText;
      if (blockText && blockText.trim()) {
        // keep custom block text
      } else {
        atcBtn.textContent = card.dataset.atcText;
      }
      if (card.dataset.available === 'true') {
        atcBtn.removeAttribute('disabled');
      } else {
        atcBtn.setAttribute('disabled', '');
      }
    }

    var thumbImg = purchaseArea.querySelector('.purchase-area__image-img');
    if (thumbImg && card.dataset.thumbUrl) {
      thumbImg.src = card.dataset.thumbUrl;
    }

    // The sticky add-to-cart bar is rendered by the "sticky-add-to-cart-cta"
    // snippet in a DIFFERENT section than the variant picker, so it cannot be
    // located via picker.closest('[data-section-id]'). Resolve it document-wide
    // and only sync the form that belongs to the SAME product: the sticky
    // <form> is wrapped by <product-form-component data-product-id="...">.
    var purchaseForm = purchaseArea.querySelector('form');
    // Note: HTMLFormElement.id is a legacy named-property owner, so a hidden
    // <input name="id"> inside the form shadows `purchaseForm.id` with an
    // input element (truthy, non-string) and breaks indexOf later. Read the id
    // attribute directly to keep the string semantics intact (D4).
    var purchaseFormId = purchaseForm && purchaseForm.getAttribute('id');
    var productId = (purchaseFormId && purchaseFormId.indexOf('product_form_') === 0)
      ? purchaseFormId.slice('product_form_'.length)
      : null;

    var stickyForms = document.querySelectorAll('[id*="product-sticky-form"]');
    var stickyForm = null;
    for (var i = 0; i < stickyForms.length; i += 1) {
      var stickyHost = stickyForms[i].closest('[data-product-id]');
      var stickyProductId = stickyHost ? stickyHost.getAttribute('data-product-id') : null;
      if (productId) {
        if (stickyProductId && String(stickyProductId) === productId) {
          stickyForm = stickyForms[i];
          break;
        }
      } else if (!stickyForm) {
        // Product id unknowable here (no purchase-area form on the page): fall
        // back to the first sticky form, safe on a single-product page.
        stickyForm = stickyForms[i];
      }
    }

    if (stickyForm) {
      var stickyIdInput = stickyForm.querySelector('input[name="id"]');
      if (stickyIdInput) stickyIdInput.value = variantId;
      var stickyQtyInput = stickyForm.querySelector('input[name="quantity"]');
      if (stickyQtyInput) stickyQtyInput.value = '1';
    }

    var stickyBars = document.querySelectorAll('sticky-add-to-cart');
    var stickyBar = null;
    for (var j = 0; j < stickyBars.length; j += 1) {
      var barProductId = stickyBars[j].getAttribute('data-product-id');
      if (productId) {
        if (barProductId && String(barProductId) === productId) {
          stickyBar = stickyBars[j];
          break;
        }
      } else if (!stickyBar) {
        // Same single-product fallback as the sticky form above.
        stickyBar = stickyBars[j];
      }
    }
    if (stickyBar) {
      stickyBar.setAttribute('data-variant-available', card.dataset.available);
      var stickyVariantEl = stickyBar.querySelector('.sticky-add-to-cart__variant');
      if (stickyVariantEl) stickyVariantEl.textContent = card.dataset.title;
      var stickyPriceEl = stickyBar.querySelector('.sticky-add-to-cart__current');
      if (stickyPriceEl) stickyPriceEl.textContent = card.dataset.priceFormatted;
      var stickyBtn = stickyBar.querySelector('.sticky-add-to-cart__button');
      if (stickyBtn) {
        if (card.dataset.available === 'true') {
          stickyBtn.removeAttribute('disabled');
        } else {
          stickyBtn.setAttribute('disabled', '');
        }
        stickyBtn.textContent = card.dataset.atcText;
      }
      var stickyImg = stickyBar.querySelector('.sticky-add-to-cart__image-img');
      if (stickyImg && card.dataset.thumbUrl) {
        stickyImg.src = card.dataset.thumbUrl;
      }
    }
  }

  // Roving tabindex for the variant radio cards (W-5). Only the checked card
  // stays in the tab order so the whole group is a single tab stop; the rest
  // are reachable with the arrow keys, per the radiogroup pattern.
  function updateRovingTabindex(picker, selectedCard) {
    var active = selectedCard
      || picker.querySelector('.variant-picker__card--selected')
      || picker.querySelector('.variant-picker__card[aria-checked="true"]');
    var cards = picker.querySelectorAll('.variant-picker__card');
    cards.forEach(function(c) {
      c.setAttribute('tabindex', c === active ? '0' : '-1');
    });
  }

  // Arrow keys inside a radiogroup move both the selection and the focus to the
  // adjacent card, wrapping at the ends (first -> last and last -> first).
  function moveVariantSelection(card, key) {
    var picker = card.closest('.variant-picker');
    if (!picker) return;

    var cards = picker.querySelectorAll('.variant-picker__card');
    if (cards.length < 2) return;

    var index = -1;
    for (var i = 0; i < cards.length; i += 1) {
      if (cards[i] === card) {
        index = i;
        break;
      }
    }
    if (index === -1) return;

    var forward = key === 'ArrowRight' || key === 'ArrowDown';
    var nextIndex = forward
      ? (index + 1) % cards.length
      : (index - 1 + cards.length) % cards.length;
    var nextCard = cards[nextIndex];
    if (!nextCard) return;

    selectVariant(nextCard);
    nextCard.focus();
  }

  function switchBundle(container, html) {
    if (container.getAnimations) {
      container.getAnimations().forEach(function(a) { a.cancel(); });
    }

    var wasHidden = container.style.display === 'none' || getComputedStyle(container).display === 'none';
    container.style.overflow = 'hidden';

    if (wasHidden && html) {
      container.innerHTML = html;
      container.style.display = '';
      container.style.height = '0px';
      var targetHeight = container.scrollHeight;
      var expand = container.animate(
        { height: ['0px', targetHeight + 'px'] },
        { duration: 220, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'forwards' }
      );
      expand.onfinish = function() {
        expand.cancel();
        container.style.height = '';
        container.style.overflow = '';
      };
      return;
    }

    if (wasHidden && !html) {
      return;
    }

    var currentHeight = container.scrollHeight;
    container.style.height = currentHeight + 'px';
    var collapse = container.animate(
      { height: [currentHeight + 'px', '0px'] },
      { duration: 220, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'forwards' }
    );
    collapse.onfinish = function() {
      collapse.cancel();
      if (html) {
        container.innerHTML = html;
        container.style.display = '';
        container.style.height = '0px';
        var targetHeight = container.scrollHeight;
        var expand = container.animate(
          { height: ['0px', targetHeight + 'px'] },
          { duration: 220, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'forwards' }
        );
        expand.onfinish = function() {
          expand.cancel();
          container.style.height = '';
          container.style.overflow = '';
        };
      } else {
        container.innerHTML = '';
        container.style.display = 'none';
        container.style.height = '';
        container.style.overflow = '';
      }
    };
  }

  (function syncInitialBundle() {
    var selectedCard = document.querySelector('.variant-picker__card--selected');
    // A bundle-driven "what's in the box" also needs its initial contents synced
    // to the server-rendered selected variant before the first interaction.
    if (selectedCard) {
      var selectedId = selectedCard.dataset.variantId;
      var boxData = document.querySelector('[data-box-variant-data]');
      var boxList = document.querySelector('[data-box-list]');
      var boxBaseItem = boxList ? boxList.querySelector('[data-box-base-item]') : null;
      if (boxData && boxList && boxBaseItem && selectedId) {
        var boxTemplate = boxData.querySelector('[data-box-variant-template][data-variant-id="' + selectedId + '"]');
        var boxFragment = document.createDocumentFragment();
        boxFragment.appendChild(boxBaseItem.cloneNode(true));
        if (boxTemplate) {
          boxTemplate.content.querySelectorAll('[data-box-bundle-item]').forEach(function(el) {
            boxFragment.appendChild(el.cloneNode(true));
          });
        }
        boxList.innerHTML = '';
        boxList.appendChild(boxFragment);
      }
    }
    if (!selectedCard) return;
    var section = selectedCard.closest('[data-section-id]');
    var purchaseArea = section
      ? section.querySelector('[data-purchase-area]')
      : document.querySelector('[data-purchase-area]');
    if (!purchaseArea) return;
    var bundleContainer = purchaseArea.querySelector('[data-purchase-area-bundle]');
    if (!bundleContainer) return;
    var bundleHtml = selectedCard.querySelector('.variant-picker__bundle-html');
    if (!bundleHtml) return;
    var html = bundleHtml.innerHTML.trim();
    if (html) {
      bundleContainer.innerHTML = html;
      bundleContainer.style.display = '';
      bundleContainer.style.opacity = '1';
    }
  })();

  // The server renders every card with tabindex="0"; normalize the group to a
  // single tab stop (the checked card) before the user can Tab into it.
  (function initRovingTabindex() {
    document.querySelectorAll('.variant-picker').forEach(function(picker) {
      updateRovingTabindex(picker);
    });
  })();
})();
